// 同源 iframe 仍共用 sessionStorage，因此依各層 iframe 的位置區分儲存空間。
// 每個頁面另保留自己的快照，避免其他 iframe 登入或登出時換掉使用中的 token。
const authKeys = ["session_token", "game_id", "admin_role", "session_allowed_ch"];

// parent、length 與索引存取可跨來源使用，不需讀取外層網站的 DOM。
const framePath = [];
for (let frame = window; frame !== frame.top; frame = frame.parent) {
  const parent = frame.parent;
  for (let index = 0; index < parent.length; index++) {
    if (parent[index] === frame) {
      framePath.unshift(index);
      break;
    }
  }
}

const frameStorageKey = (path) =>
  `megnpc:frame-auth:${JSON.stringify([window.location.pathname, path])}`;
const storageKey = frameStorageKey(framePath);
const frameValues = Object.create(null);
const isEmbedded = window.self !== window.top;

if (isEmbedded) {
  try {
    const saved = JSON.parse(window.sessionStorage.getItem(storageKey) || "{}");
    authKeys.forEach((key) => {
      if (saved && typeof saved[key] === "string") frameValues[key] = saved[key];
    });
  } catch (e) {
    // 儲存空間被封鎖或資料損壞時，仍可使用目前頁面的記憶體登入。
  }
}

const persistFrame = () => {
  try {
    window.sessionStorage.setItem(storageKey, JSON.stringify(frameValues));
  } catch (e) {
    // Safari 等環境若不允許儲存，登入狀態保留到此頁面關閉為止。
  }
};

// 獨立開啟的頁面沿用原本的 localStorage 行為；iframe 不讀取舊的共用憑證。
const authStorage = isEmbedded
  ? {
      getItem(key) {
        return frameValues[key] === undefined ? null : frameValues[key];
      },
      setItem(key, value) {
        frameValues[key] = String(value);
        persistFrame();
      },
      removeItem(key) {
        delete frameValues[key];
        persistFrame();
      },
    }
  : window.localStorage;

// 原有多 NPC 分頁由父頁登入一次，只將已獲授權的 Session 提供給其子 iframe。
export function seedFrameSession(ch, index) {
  let allowed = [];
  try {
    allowed = JSON.parse(authStorage.getItem("session_allowed_ch") || "[]");
  } catch (e) {
    return;
  }
  if (
    !authStorage.getItem("session_token") ||
    (!authStorage.getItem("admin_role") &&
      authStorage.getItem("game_id") !== ch &&
      !(Array.isArray(allowed) && allowed.includes(ch)))
  ) {
    return;
  }
  const values = {};
  authKeys.forEach((key) => {
    const value = authStorage.getItem(key);
    if (value !== null) values[key] = value;
  });
  try {
    window.sessionStorage.setItem(
      frameStorageKey([...framePath, index]),
      JSON.stringify(values)
    );
  } catch (e) {
    // 與原本一樣，無法在 iframe 使用儲存空間時由登入頁處理。
  }
}

export default authStorage;
